import React from 'react'
import styles from './styles.module.scss'
import '@fortawesome/fontawesome-free/css/all.css'

const Button = (props) => {
  const onClick = (e) => {
    e.stopPropagation()
    props.onClick(props.value)
  }

  return <div onClick={onClick}>{props.label}</div>
}

const buttons = [
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  {
    value: 'del',
    label: <i className='fa fa-backspace' />
  },
  0,
  {
    value: 'ok',
    label: <i className='fa fa-check' />
  }
]

class NumericInput extends React.Component {
  #firstClick

  constructor(props) {
    super(props)

    this.state = {
      value: String(this.props.value) || ''
    }

    this.handleOnBackdropClick = this.handleOnBackdropClick.bind(this)
    this.handleOnButtonClick = this.handleOnButtonClick.bind(this)
    this.onKeyPress = this.onKeyPress.bind(this)

    this.#firstClick = true
  }

  componentDidMount() {
    document.addEventListener('keypress', this.onKeyPress)
  }

  componentWillUnmount() {
    document.removeEventListener('keypress', this.onKeyPress)
  }

  handleOnBackdropClick(e) {
    e.stopPropagation()
    this.cancel()
  }

  handleOnButtonClick(e) {
    e === 'del'
      ? this.deleteDigit()
      : e === 'ok'
      ? this.submit()
      : this.addDigit(e)
  }

  submit() {
    this.props.onClose && this.props.onClose(this.state.value)
  }

  cancel() {
    this.props.onCancel && this.props.onCancel()
  }

  deleteDigit() {
    this.setState({ value: this.state.value.slice(0, -1) })
  }

  addDigit(e) {
    let value = (this.#firstClick ? '' : this.state.value) + String(e)

    if (this.#firstClick) this.#firstClick = false

    if (value.length > 2) value = value.slice(1)

    this.setState({ value })
  }

  clear() {
    this.setState({ value: '' })
  }

  onKeyPress(e) {
    e.preventDefault()

    if (e.which === 8) this.deleteDigit()
    else if (e.which === 13) this.submit()
    else if (e.which === 27) this.close()
    else if (e.which === 46) this.clear()
    else if (e.which >= 48 && e.which <= 57) this.addDigit(e.which - 48)
  }

  render() {
    return (
      <div className={styles.NumericInput}>
        <div className={styles.Backdrop} onClick={this.handleOnBackdropClick} />

        <div className={styles.Panel}>
          <div className={styles.Display}>{this.state.value}</div>

          <div className={styles.Buttons}>
            {buttons.map((e) => {
              return (
                <Button
                  onClick={this.handleOnButtonClick}
                  value={typeof e === 'number' ? e : e.value}
                  key={typeof e === 'number' ? e : e.value}
                  label={typeof e === 'number' ? e : e.label}
                />
              )
            })}
          </div>
        </div>
      </div>
    )
  }
}

export default NumericInput
